var _defs, _path, _g, _g2, _g3, _tspan, _tspan2, _tspan3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504.62,
    height: 343.43,
    viewBox: "0 0 133.51 90.866",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWideHeavy-2-1",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 0-3 3h-2l3-3-3-3h2z",
    fill: "context-stroke",
    fillRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m80.698 44.461h5.2917v-15.412h5.5562",
    fill: "none",
    stroke: "#666",
    strokeDasharray: "0.79375, 0.79375",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.13229
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.195 -4.0237)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.1953 7.9375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.13229,
    y: 5.2917,
    width: 79.375,
    height: 68.792,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.13229 13.229 79.375 0.14014",
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.2779,
    y: 7.1,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#0100ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.589,
    y: 7.1,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 7.1,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 15.346,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#6766ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 15.346,
    width: 21.167,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffcb66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 15.346,
    width: 22.49,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 21.159,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#33f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 21.159,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 21.159,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 26.971,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#4c4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 26.971,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 26.971,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 32.784,
    width: 21.167,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#0200ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 32.784,
    width: 18.521,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 32.784,
    width: 18.521,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 38.597,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 38.597,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffd480"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 38.597,
    width: 17.198,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 44.41,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#4d4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 44.41,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 50.222,
    width: 17.198,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#99f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 44.41,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 50.222,
    width: 17.198,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#fd9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 50.222,
    width: 17.198,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 56.035,
    width: 21.167,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#1a1aff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 56.035,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffb21a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 56.035,
    width: 15.875,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 61.848,
    width: 17.198,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#4d4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 61.848,
    width: 17.198,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 61.848,
    width: 21.167,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2778,
    y: 67.661,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#3533ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 67.661,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.901,
    y: 67.661,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#f33"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.2536 11.642)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.68,
    y: 36.411,
    width: 19.844,
    height: 3.9688,
    rx: 1.9844,
    ry: 1.9844,
    fill: "#003aff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.9,
    y: 5.5125,
    width: 19.844,
    height: 3.175,
    rx: 1.5875,
    ry: 1.5875,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.016,
    y: 27.289,
    width: 33.163,
    height: 5.6944,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#9c9fd7",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.13229
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.343,
    y: 28.945,
    width: 15.875,
    height: 2.3812,
    rx: 1.1906,
    ry: 1.1906,
    fill: "#f99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.343,
    y: 21.222,
    width: 22.49,
    height: 2.3812,
    rx: 1.1906,
    ry: 1.1906,
    fill: "#ffdc99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.242,
    y: 19.566,
    width: 33.163,
    height: 5.6944,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#9c9fd7",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.13229
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.343,
    y: 13.499,
    width: 19.844,
    height: 2.3812,
    rx: 1.1906,
    ry: 1.1906,
    fill: "#9a99ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.242,
    y: 11.843,
    width: 33.163,
    height: 5.6944,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#9c9fd7",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.13229
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.28,
    y: 2.3776,
    width: 38.635,
    height: 40.472,
    rx: 1.0583,
    ry: 1.0583,
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.1953 7.9375)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#666",
    strokeDasharray: "0.79375, 0.79375",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.13229
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107.09 44.781 1e-5 5.4901h-11.84v7.276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.13 44.781v9.4589h-3.9688v10.186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.18 44.781v9.4589h3.9688v3.3073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.22 44.781-1e-5 5.4901h11.906v14.155"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0043971 0 0 .0043971 114.38 60.781)",
    stroke: "#392781"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(3.6036)",
    d: "m41 25h252c17.12 0 31 17.12 31 31v175.13c0 17.12-13.879 31.003-31 31.003h-252c-17.12 0-31-17.123-31-31.003v-175.13c0-17.12 13.879-31 31-31z",
    fill: "none",
    strokeWidth: 13.331
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(3.6036)",
    d: "m9.9998 86h314",
    fill: "none",
    strokeWidth: 13.331
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#392781",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.3 205.41c0 17.91-14.52 32.43-32.43 32.43-17.914 0-32.434-14.52-32.434-32.43 0-17.914 14.52-32.434 32.434-32.434 17.91 0 32.43 14.52 32.43 32.434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.2 205.41c0 17.91-14.523 32.43-32.434 32.43s-32.434-14.52-32.434-32.43c0-17.914 14.523-32.434 32.434-32.434s32.434 14.52 32.434 32.434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.02 205.41c0 17.91-14.523 32.43-32.434 32.43-17.914 0-32.434-14.52-32.434-32.43 0-17.914 14.52-32.434 32.434-32.434 17.91 0 32.434 14.52 32.434 32.434"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m106.18 68.711c0.23653 0 0.42327 0.19295 0.42327 0.42326 0 0.23652-0.18674 0.42325-0.42327 0.42325-0.23029 0-0.42324-0.18673-0.42324-0.42325 0-0.23031 0.19295-0.42326 0.42324-0.42326zm-1.3374 2.5646 0.43151-0.52766 2.574-0.0017c0.3859-2.34e-4 0.69715-0.31744 0.69715-0.69714v-1.8237c0-0.38591-0.31125-0.69714-0.69715-0.69714h-3.33c-0.38594 0-0.69715 0.31122-0.69715 0.69714v1.8237c0 0.37968 0.31121 0.69714 0.69715 0.69714h0.35478zm0.46608-0.39258-0.57275 0.7721v-0.77182h-0.21785c-0.4606 0-0.83407-0.37968-0.83407-0.83408v-1.8237c0-0.4606 0.37347-0.83408 0.83407-0.83408h3.33c0.45439 0 0.83408 0.37347 0.83408 0.83408v1.8237c0 0.45441-0.37969 0.83408-0.83408 0.83408zm-0.24283-2.172c0.23031 0 0.42325 0.19295 0.42325 0.42325 0 0.23652-0.19294 0.42326-0.42325 0.42326-0.23653 0-0.42325-0.18674-0.42325-0.42326 0-0.23031 0.18672-0.42325 0.42325-0.42325zm0 0.13693c-0.15561 0-0.28633 0.13072-0.28633 0.28632 0 0.16184 0.13078 0.28632 0.28633 0.28632 0.15561 0 0.28631-0.12449 0.28631-0.28632 0-0.1556-0.13076-0.28632-0.28631-0.28632zm2.2346-0.13693c0.2303 0 0.42325 0.19295 0.42325 0.42325 0 0.23652-0.19295 0.42326-0.42325 0.42326-0.23653 0-0.42326-0.18674-0.42326-0.42326 0-0.23031 0.18673-0.42325 0.42326-0.42325zm0 0.13693c-0.16184 0-0.28633 0.13072-0.28633 0.28632 0 0.16184 0.12449 0.28632 0.28633 0.28632 0.15559 0 0.28632-0.12449 0.28632-0.28632 0-0.1556-0.13077-0.28632-0.28632-0.28632zm-1.1204 0c-0.15561 0-0.28632 0.13072-0.28632 0.28632 0 0.16184 0.13077 0.28632 0.28632 0.28632 0.16184 0 0.28634-0.12449 0.28634-0.28632 0-0.1556-0.1245-0.28632-0.28634-0.28632z",
    fill: "#333",
    stroke: "#392781",
    strokeWidth: 0.11633
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.249 65.179h3.5243c0.4813 0 0.87215-0.39085 0.87215-0.87216v-2.3567c0-0.48132-0.39085-0.87216-0.87215-0.87216h-3.5243c-0.48132 0-0.87215 0.39085-0.87215 0.87216l2.8e-5 2.3567c0 0.48132 0.39085 0.87216 0.87215 0.87216zm4.0645-0.87216c0 0.2979-0.2423 0.54023-0.54022 0.54023h-3.5243c-0.2979 0-0.54024-0.24231-0.54024-0.54023l2.8e-5 -2.3567c0-0.07553 0.01576-0.1477 0.04399-0.21327l1.848 1.5651c0.1236 0.10457 0.27469 0.15684 0.4257 0.15684 0.15103 0 0.30206-0.05226 0.42488-0.156l1.8256-1.5443c0.0233 0.05975 0.0357 0.12448 0.0357 0.19252v2.3559zm-0.54104-2.897c0.10952 0 0.21078 0.03319 0.29625 0.0888l-1.8323 1.5501c-0.12196 0.10373-0.29956 0.10373-0.42155 0l-1.8439-1.5618c0.08136-0.04895 0.17594-0.07718 0.27716-0.07718z",
    fill: "#392781",
    strokeWidth: 0.0069153
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.26 67.403c0.34383 0 0.62255 0.27874 0.62255 0.62255v2.4902c0 0.61887-0.5017 1.1206-1.1206 1.1206-0.3838 0-0.72253-0.19294-0.92448-0.48712l-0.0123-0.0172 3e-3 6e-3 -2.8034-6e-5c-0.34381 0-0.62254-0.27873-0.62254-0.62255v-2.4902c0-0.34381 0.27873-0.62254 0.62254-0.62254zm-0.49802 2.2412c-0.48135 0-0.87157 0.39021-0.87157 0.87157s0.39022 0.87157 0.87157 0.87157 0.87155-0.39021 0.87155-0.87157-0.3902-0.87157-0.87155-0.87157zm0 0.24902c0.0688 0 0.12451 0.0557 0.12451 0.12451h0.12455c0.0687 0 0.12454 0.0557 0.12454 0.12451 0 0.0656-0.0509 0.11942-0.1152 0.12417l-0.01 3.4e-4h-0.37352c-0.0345 0-0.0623 0.0279-0.0623 0.0622 0 0.0319 0.0239 0.0582 0.055 0.0618l6e-3 4.3e-4h0.24901c0.1719 0 0.31129 0.13936 0.31129 0.31127 0 0.16739-0.13214 0.30392-0.29779 0.31099l-0.0134 2.9e-4c0 0.0688-0.0557 0.1245-0.1245 0.1245-0.0687 0-0.12455-0.0557-0.12455-0.1245h-0.12454c-0.0688 0-0.12451-0.0557-0.12451-0.12451 0-0.0656 0.0509-0.11942 0.1152-0.12418l0.01-3.4e-4h0.37351c0.0345 0 0.0623-0.0279 0.0623-0.0623 0-0.0319-0.024-0.0582-0.055-0.0618l-6e-3 -4.2e-4h-0.24901c-0.17193 0-0.31129-0.13937-0.31129-0.31128 0-0.16739 0.13213-0.30392 0.29777-0.31099l0.0134-2.8e-4c0-0.0688 0.0558-0.12451 0.12453-0.12451zm0.49802-2.2412h-4.2333c-0.20159 0-0.3659 0.1597-0.37326 0.35952l-2.9e-4 0.014v2.4902c0 0.2016 0.15972 0.36591 0.35952 0.37327l0.0141 2.6e-4 2.6784 2e-5 -3e-4 -8.9e-4c-0.0411-0.11659-0.0635-0.24203-0.0635-0.37268 0-0.0825 0.01-0.16295 0.0258-0.24039l9.5e-4 -9e-3 -0.27679-2e-5c-0.0688 0-0.12452-0.0557-0.12452-0.1245s0.0558-0.12451 0.12452-0.12451l0.36547 4e-5 9e-3 -0.017c0.1865-0.35977 0.56233-0.60558 0.99553-0.60558 0.34923 0 0.66118 0.15979 0.86672 0.41023l0.01 0.0112-3e-3 -5e-3 -1.1e-4 -1.7859c0-0.2016-0.15972-0.36591-0.35955-0.37327zm-3.4862 2.3657c0.0687 0 0.1245 0.0557 0.1245 0.12451 0 0.0688-0.0558 0.12451-0.1245 0.12451h-0.62255c-0.0687 0-0.12455-0.0558-0.12455-0.12451 0-0.0688 0.0559-0.12451 0.12455-0.12451zm1.1206 0c0.0688 0 0.12454 0.0557 0.12454 0.12451 0 0.0688-0.0558 0.12451-0.12454 0.12451h-0.62255c-0.0687 0-0.12452-0.0558-0.12452-0.12451 0-0.0688 0.0559-0.12451 0.12452-0.12451zm-0.99607-1.7431c0.20631 0 0.37352 0.16723 0.37352 0.37353v0.49804c0 0.2063-0.16721 0.37353-0.37352 0.37353h-0.49805c-0.20627 0-0.37349-0.16723-0.37349-0.37353v-0.49804c0-0.2063 0.16722-0.37353 0.37349-0.37353zm0.12453 0.74706h-0.74707v0.12451c0 0.0656 0.0509 0.11942 0.1152 0.12417l0.01 3.5e-4h0.49801c0.0657 0 0.1195-0.0508 0.12413-0.1152l3.5e-4 -9e-3zm-0.12453-0.49804h-0.49805c-0.0657 0-0.1195 0.0508-0.12411 0.11522l-3.7e-4 9e-3v0.1245h0.74706v-0.1245c0-0.0656-0.0509-0.11943-0.1152-0.12418zm3.2372-0.24902c0.0688 0 0.12454 0.0557 0.12454 0.12451 0 0.0688-0.0558 0.12451-0.12454 0.12451h-0.62255c-0.0688 0-0.12454-0.0557-0.12454-0.12451 0-0.0688 0.0558-0.12451 0.12454-0.12451z",
    fill: "#392781"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#392781",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.52917
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.4559 0 0 .4559 55.936 36.863)",
    d: "m91.819 47.666 5.7493 9.9362-5.7304 9.9472-11.48 0.01093-5.7493-9.9362 5.7304-9.9472z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.4559 0 0 .4559 145.43 42.948)",
    d: "m91.819 47.666 5.7493 9.9362-5.7304 9.9472-11.48 0.01093-5.7493-9.9362 5.7304-9.9472z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.4559 0 0 .4559 88.891 42.948)",
    d: "m91.819 47.666 5.7493 9.9362-5.7304 9.9472-11.48 0.01093-5.7493-9.9362 5.7304-9.9472z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.4559 0 0 .4559 77.779 36.863)",
    d: "m91.819 47.666 5.7493 9.9362-5.7304 9.9472-11.48 0.01093-5.7493-9.9362 5.7304-9.9472z"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-5)",
    x: 3.5572395,
    y: 12.636129,
    fill: "#392781",
    fontFamily: "Chilanka",
    fontSize: "7.1438px",
    stroke: "#392781",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 3.5572395,
    y: 12.636129,
    fontFamily: "'Coming Soon'",
    fontSize: "7.1438px",
    strokeWidth: 0
  }, "Definition"))), /*#__PURE__*/React.createElement("path", {
    d: "m40.93 5.3359c-0.69866 0.031937-1.6221 0.38855-2.8398 1.1074l0.13476 0.22852c1.1998-0.70826 2.1012-1.0421 2.7188-1.0703 0.30876-0.014114 0.54275 0.04412 0.72266 0.16211 0.17991 0.11799 0.31129 0.29947 0.40039 0.55273 0.1782 0.50653 0.16604 1.2999-0.01953 2.3086-0.18557 1.0087-0.53839 2.2316-1.0195 3.6133l0.24805 0.08789c0.48382-1.3894 0.84369-2.6241 1.0332-3.6543 0.18951-1.0302 0.2149-1.8547 0.0078-2.4434-0.10354-0.29433-0.27105-0.53155-0.50585-0.68555-0.2348-0.15399-0.53153-0.223-0.88086-0.20703z",
    color: "#000000",
    fill: "#392781",
    fillRule: "evenodd",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.064 12.532-0.48857-1.0106 0.17402-0.49973 0.48857 1.0106 1.0106-0.48857-0.17402 0.49973z",
    color: "#000000",
    fill: "#392781",
    fillRule: "evenodd",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(8)",
    x: 113.75333,
    y: -5.9351878,
    fill: "#392781",
    fontFamily: "Chilanka",
    fontSize: "7.1438px",
    stroke: "#392781",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 113.75333,
    y: -5.9351878,
    fontFamily: "'Coming Soon'",
    fontSize: "7.1438px",
    strokeWidth: 0
  }, "Form"))), /*#__PURE__*/React.createElement("path", {
    d: "m112.98 6.2578c-1.8964 0.031682-3.1639 0.21025-3.9726 0.5332-0.40438 0.16148-0.69665 0.36112-0.88672 0.60352-0.19007 0.2424-0.27134 0.52721-0.26172 0.82813 0.0192 0.60183 0.37496 1.2753 0.88281 2.0332 0.50786 0.75792 1.1764 1.5974 1.8516 2.5059l0.21094-0.15625c-0.6784-0.91272-1.3453-1.7542-1.8438-2.498-0.49841-0.74384-0.81994-1.3921-0.83594-1.8926-8e-3 -0.25023 0.0531-0.46239 0.20508-0.65625 0.15201-0.19386 0.40198-0.37159 0.77735-0.52148 0.75073-0.29979 1.9955-0.48224 3.877-0.51367z",
    color: "#000000",
    fill: "#392781",
    fillRule: "evenodd",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.85 12.896-1.1106-0.16355-0.31567-0.4247 1.1106 0.16355 0.16354-1.1106 0.31567 0.4247z",
    color: "#000000",
    fill: "#392781",
    fillRule: "evenodd",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(11)",
    x: 103.3824,
    y: 68.288872,
    fill: "#392781",
    fontFamily: "Chilanka",
    fontSize: "7.1438px",
    stroke: "#392781",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 103.3824,
    y: 68.288872,
    fontFamily: "'Coming Soon'",
    fontSize: "7.1438px",
    strokeWidth: 0
  }, "Mechanism"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m117.63 86.106c2.9871-2.8249 6.428-6.9399-1.3244-7.4551",
    fill: "none",
    markerEnd: "url(#ArrowWideHeavy-2-1)",
    stroke: "#392781",
    strokeWidth: 0.26458
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPicture);
export default __webpack_public_path__ + "static/media/big-picture.0a39995f2a26f60dac47ce4e2f1b3b59.svg";
export { ForwardRef as ReactComponent };